import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setUser } from "../../../ReduxStore/UserSlice";
import { USER_TYPES, BORROWER_TYPES, ENTITY_TYPES } from "../../../utils/constants";
// Initialize toast
export const showToast = (message, type) => {
  if (type === "success") {
    toast.success(message, {
      position: "top-center",
      autoClose: 2000, // Toast disappears after 3 seconds
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
    });
  } else if (type === "error") {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
    });
  } else if (type === "info") {
    toast.info(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
    });
  } else {
    toast(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
    });
  }
};

export function base64ToFile(base64, filename) {
  if (!base64 || !filename) {
    console.error('Invalid arguments for base64ToFile', { base64: !!base64, filename: !!filename });
    return null;
  }

  try {
    const arr = base64.split(',');

    let mime;
    try {
      mime = arr[0].match(/:(.*?);/)[1];
    } catch (e) {
      if (filename.toLowerCase().endsWith('.pdf')) {
        mime = 'application/pdf';
      } else if (filename.toLowerCase().endsWith('.png')) {
        mime = 'image/png';
      } else if (filename.toLowerCase().endsWith('.jpg') || filename.toLowerCase().endsWith('.jpeg')) {
        mime = 'image/jpeg';
      } else {
        mime = 'application/octet-stream';
      }
    }

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  } catch (error) {
    console.error('Error converting base64 to file:', error);
    return null;
  }
}

export async function fetchFileFromUrl(url, filename) {
  // Check if network requests are disabled (for react-snap static generation)
  if (process.env.REACT_APP_ENABLE_NETWORK_REQUESTS !== 'true') {
    console.log('Network requests disabled - returning mock file for static generation');
    // Return a mock file object to prevent build failures
    return new File([new ArrayBuffer(0)], filename, { type: 'application/octet-stream' });
  }

  try {
    const response = await fetch(url);
    const blob = await response.blob();

    let mimeType = 'application/octet-stream';

    if (filename.toLowerCase().endsWith('.pdf')) {
      mimeType = 'application/pdf';
    } else if (filename.toLowerCase().endsWith('.png')) {
      mimeType = 'image/png';
    } else if (filename.toLowerCase().endsWith('.jpg') || filename.toLowerCase().endsWith('.jpeg')) {
      mimeType = 'image/jpeg';
    }

    return new File([blob], filename, { type: mimeType });
  } catch (error) {
    console.error('Error fetching file from URL:', error);
    return null;
  }
}

/**
 * Compresses an image file using browser-image-compression.
 *
 * @param {File} file - The image file to compress.
 * @param {Object} [options={}] - Optional compression options.
 * @returns {Promise<File>} - The compressed image file.
 */
export default async function compressImage(file, options = {
  maxSizeMB: 0.1,
  maxWidthOrHeight: 1024
}) {
  const defaultOptions = {
    maxSizeMB: 0.5,             // Maximum size in MB
    maxWidthOrHeight: 1920,   // Max width or height
    useWebWorker: true,       // Use multi-threading for performance
  };

  const compressionOptions = { ...defaultOptions, ...options };

  try {
    const compressedFile = await imageCompression(file, compressionOptions);
    return compressedFile;
  } catch (error) {
    console.error('Error while compressing image:', error);
    return file; // Return original file if compression fails
  }
}

export const isLoggedIn = (userData) => {
  return !!userData?.jwtToken || !!localStorage.getItem('jwtToken');
};

const LOGIN_EVENT_KEY = 'dequitec_login_event';
const LOGIN_CHANNEL = new BroadcastChannel('dequitec_login_channel');

const LOGOUT_EVENT_KEY = 'dequitec_logout_event';
const LOGOUT_CHANNEL = new BroadcastChannel('dequitec_logout_channel');

export const autoLogin = (response,dispatch) => {
  try {
    if (!response?.jwtToken) return false;

    const isLender =
      (response?.UserType || response?.UserType)?.toLowerCase() === "lender";
  console.log("Complete User Data:", !isLoggedIn(response),!response?.jwtToken,isLender && response.lender?.verified,isLender);
    if (isLender && response.lender?.verified) {
      localStorage.setItem("jwtToken", response.jwtToken);
      localStorage.setItem("user", JSON.stringify(response));
      localStorage.setItem("userType", "lender");

      if (response?.lender?.lenderId) {
        localStorage.setItem("lenderId", response.lender.lenderId);
      }

      dispatch(setUser(response));
    } else if (isLender) {
      localStorage.setItem("tempJwtToken", response.jwtToken);
      localStorage.setItem("tempUuid", response.UUID);
      return false;
    } else if (isLoggedIn(response)) {
      localStorage.setItem("jwtToken", response.jwtToken);
      localStorage.setItem("user", JSON.stringify(response));

      if (response?.businessType) {
        localStorage.setItem("userBusinessType", response?.businessType || "");
      }
      if (response?.entityType) {
        localStorage.setItem("userEntityType", response?.entityType || "");
      }
      if (response?.userType|| response?.UserType) {
        localStorage.setItem(
          "userType",
          (response?.userType|| response?.UserType)?.toLowerCase() || ""
        );
      }

      dispatch(setUser(response));
    } else {
      return false;
    }

    localStorage.setItem(LOGIN_EVENT_KEY, "1");
    LOGIN_CHANNEL.postMessage({ type: "LOGIN_SUCCESS" });

    console.log("Complete User Data11111:", true);

    return true;
  } catch (error) {
    console.error("Error in autoLogin:", error);
    showToast("Auto login failed. Please try again.", "error");
    return false;
  }
};


export const logoutSync = (dispatch) => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('user');
  localStorage.removeItem('userType');
  localStorage.removeItem('lenderId');
  localStorage.removeItem('userBusinessType');
  localStorage.removeItem('userEntityType');
  localStorage.removeItem('tempJwtToken');
  localStorage.removeItem('tempUuid');

  if (dispatch) dispatch(setUser({}));

  localStorage.setItem(LOGOUT_EVENT_KEY, '1');
  LOGOUT_CHANNEL.postMessage({ type: 'LOGOUT' });
};

window.addEventListener('storage', e => {
  if (e.key === LOGIN_EVENT_KEY && localStorage.getItem('jwtToken')) {
    window.location.reload();
  }
  if (e.key === LOGOUT_EVENT_KEY) {
    localStorage.clear();
    window.location.replace('/');
  }
});

LOGIN_CHANNEL.onmessage = () => {
  if (localStorage.getItem('jwtToken')) {
    window.location.reload();
  }
};

LOGOUT_CHANNEL.onmessage = () => {
  localStorage.clear();
  window.location.replace('/');
};

export const TOKEN_KEYS = {
  JWT: 'jwtToken',
  BUSINESS_TYPE: 'userBusinessType',
  ENTITY_TYPE: 'userEntityType',
  USER_INFO: 'user',
  SESSION_TIMEOUT: 'sessionTimeoutId',
  USER_TYPE: 'userType',
  BORROWER_TYPE: 'borrowerType',
};

export const setTokenIfNeeded = (key, value, alternateValues = []) => {
  if (!value && alternateValues?.length > 0) {
    value = alternateValues.find(v => v);
  }

  // Normalize the values to match constants
  if (key === TOKEN_KEYS.USER_TYPE) {
    value = value?.toLowerCase() === 'lender' ? USER_TYPES.LENDER : USER_TYPES.BORROWER;
  } else if (key === TOKEN_KEYS.BORROWER_TYPE) {
    value = value?.toLowerCase() === 'entity' ? BORROWER_TYPES.ENTITY : BORROWER_TYPES.INDIVIDUAL;
  } else if (key === TOKEN_KEYS.ENTITY_TYPE) {
    if (value?.toLowerCase().includes('company')) {
      value = ENTITY_TYPES.COMPANY;
    } else if (value?.toLowerCase().includes('partnership')) {
      value = ENTITY_TYPES.PARTNERSHIP_FIRM;
    } else if (value?.toLowerCase().includes('proprietorship')) {
      value = ENTITY_TYPES.propreitorship_firm;
    }
  }

  if (value) {
    localStorage.setItem(key, value);
  }
};

export const preserveAuthTokens = () => {
  const tokens = {
    currentToken: localStorage.getItem(TOKEN_KEYS.JWT),
    userBusinessType: localStorage.getItem(TOKEN_KEYS.BUSINESS_TYPE),
    userEntityType: localStorage.getItem(TOKEN_KEYS.ENTITY_TYPE),
    userInfo: localStorage.getItem(TOKEN_KEYS.USER_INFO),
    timestamp: Date.now()
  };

  window._preservedAuthTokens = tokens;
  return tokens;
};

export const restoreAuthTokens = (user) => {
  try {
    const preserved = window._preservedAuthTokens;
    if (!preserved) return;

    localStorage.removeItem(TOKEN_KEYS.SESSION_TIMEOUT);

    const setTokenIfNeeded = (key, value, fallbacks = []) => {
      if (!localStorage.getItem(key)) {
        const validValue = value || fallbacks.find(fb => fb);
        if (validValue) localStorage.setItem(key, validValue);
      }
    };

    setTokenIfNeeded(TOKEN_KEYS.JWT, preserved.currentToken);
    setTokenIfNeeded(TOKEN_KEYS.BUSINESS_TYPE, preserved.userBusinessType, [
      user?.user?.borrowerType,
      user?.user?.BorrowerType
    ]);
    setTokenIfNeeded(TOKEN_KEYS.ENTITY_TYPE, preserved.userEntityType, [
      user?.user?.entityType,
      user?.user?.UserType
    ]);
    setTokenIfNeeded(TOKEN_KEYS.USER_INFO, preserved.userInfo);

  } catch (error) {
    console.error('[AUTH-TOKENS] Error restoring tokens:', error);
  }
};

export const ensureAuthTokens = (user) => {
  if (!user?.user?.jwtToken) return;

  const setTokenIfNeeded = (key, value) => {
    if (value && !localStorage.getItem(key)) {
      localStorage.setItem(key, value);
    }
  };

  setTokenIfNeeded(TOKEN_KEYS.JWT, user.user.jwtToken);
  setTokenIfNeeded(TOKEN_KEYS.ENTITY_TYPE, user.user?.entityType || user.user?.UserType);
  setTokenIfNeeded(TOKEN_KEYS.BUSINESS_TYPE, user.user?.borrowerType || user.user?.BorrowerType);
};

export const convertAndSetFile = (fileData) => {
  if (fileData?.base64 && fileData?.filename) {
    return base64ToFile(fileData.base64, fileData.filename);
  } else if (fileData?.remote === true && (fileData?.url || fileData?.documentPath)) {
    return fileData;
  }
  return null;
};

export const handleOpenPrivacyPolicy = () => {
  window.open("/privacy-policy", "_blank", "noopener,noreferrer");
};

export const handleOpenTermsOfService = () => {
  window.open("/terms-of-service", "_blank", "noopener,noreferrer");
};

export const handleOpenContactUs = () => {
  window.open("/contact-us", "_blank", "noopener,noreferrer");
};

export const titleToSlug = (title) => {
  if (title === '') return '-';                  // only empty string → "-"
  if (!title || typeof title !== 'string') return '';  // invalid values → ""

  let slug = title
    .replace(/\s+/g, '-')     // spaces → "-"
    .replace(/-+/g, '-')      // multiple "-" → single
    .replace(/^-+|-+$/g, ''); // trim "-" at edges

  if (!slug || slug.trim() === '') {
    slug = 'untitled';
  }

  return encodeURIComponent(slug);
};

export const slugToTitle = (slug) => {
  if (!slug || typeof slug !== 'string') return '';
  
  let title = slug.replace(/-/g, ' ');
  
  return title;
};

  const convertAndSetfile = (fieldName, fileData) => {
    if (fileData?.base64 && fileData?.filename) {
      const fileObj = base64ToFile(fileData.base64, fileData.filename);
      return fileObj;
    } else if (fileData?.remote === true && fileData?.url) {
      return fileData;
    } else {
      return null;
    }
  };


export const getEntityTypeLabel = (entityType) => {
    if (!entityType) return `Non Company`;

    switch (entityType.toLowerCase()) {
      case ENTITY_TYPES.COMPANY.toLowerCase():
        return "Company";
      case ENTITY_TYPES.PARTNERSHIP_FIRM.toLowerCase():
        return "Partnership Firm";
      case ENTITY_TYPES.propreitorship_firm.toLowerCase():
        return "Proprietorship Firm";
      default:
        return entityType;
    }
  };

  export const getFinancialYear = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 1-based month
    if (month >= 4) {
      return `${year}-${year + 1}`;
    } else {
      return `${year - 1}-${year}`;
    }
  };

